import { useState } from "react";
import MakeOfferCreate from "./MakeOfferCreate";
import MakeOfferReview from "./MakeOfferReview";
import MakeOfferSuccess from "./MakeOfferSuccess";
import MakeOfferFail from "./MakeOfferFail";
import { useSoundPath } from "hooks/useSoundPath";
import ModalWindow from "components/ModalWindow";

const MakeOfferPopup = ({close}) => {
  const playSound = useSoundPath();
  const [step, setStep] = useState('create');
  const [offerData, setOfferData] = useState({
    amount: null,
    days: null,
    hours: null,
  });

  const nextStep = () => {
    playSound('main');
    if (step === 'create') {
      setStep('review')
    } else if ('review') {
      setStep('success')
    }
  }

  const closeWindow = () => {
    close()
    setStep('create');
  }

  return (
    <ModalWindow close={closeWindow}>
      {step === 'create' && <MakeOfferCreate nextStep={nextStep} closeWindow={closeWindow} offerData={offerData} setOfferData={setOfferData} />}
      {step === 'review' && <MakeOfferReview nextStep={nextStep} closeWindow={closeWindow} setStep={setStep} offerData={offerData} />}
      {step === 'success' && <MakeOfferSuccess closeWindow={closeWindow} />}
      {step === 'fail' && <MakeOfferFail closeWindow={closeWindow} />}
    </ModalWindow>
  )
}

export default MakeOfferPopup;
